import {
  getQueryString,
  updateFilterStore,
  normalizeFilterQuery,
} from 'pages/category/util'
import filterDuck from 'components/filter/filter-options/duck'

const syncRoutePathForSearch = ({ filterData, sortData } = {}) => {
  const pathPrefix = window.location.pathname
  let textQuery = {}
  const { queryString } = getQueryString({ filterData, sortData })
  if (queryString) {
    textQuery = `?${queryString}`
  }

  // if it is ssr (on this point, when change filter that always load with SSR),
  // that will be reload the web, so we solve by using pushState
  // to help to change url without reload all page.
  window.history.pushState({}, '', `${pathPrefix}${textQuery}`)
}

const getFiltersFromQuery = ({
  brandQuery,
  categoriesQuery,
  categoryQuery,
  colorQuery,
  priceQuery,
  sizeQuery,
  store,
  asPath,
}) => {
  store.dispatch(filterDuck.creators.clean())

  const filterData = normalizeFilterQuery({
    sizeQuery,
    brandQuery,
    priceQuery,
    colorQuery,
    asPath,
    isSearch: true,
  })

  if (
    [
      sizeQuery,
      brandQuery,
      categoryQuery,
      categoriesQuery,
      priceQuery,
      colorQuery,
    ].some(Boolean)
  ) {
    updateFilterStore(filterData, store)
  }

  return filterData
}

export { syncRoutePathForSearch, getFiltersFromQuery }
